import { default as utils } from './utils.js';
import Module from '../core/module';

export default class View extends Module {
  static find(context, selector, scanLazy) {
    if (selector === undefined) {
      selector = context;
      context = 'body';
    }

    this.$(context)
      .find(selector)
      .each(el => {
        var isLazy = el.hasAttribute('lazy');
        if (isLazy && !scanLazy) return;

        // find the view ONLY once
        if (el.__view__) {
          el.__view__.refresh && el.__view__.refresh();
        } else {
          el.__view__ = new this(el);
        }
      });
  }

  //
  _preInit(selector, data) {
    var el = null;

    // multiple dom elements
    if (utils.is.obj(selector, true)) {
      this.$element = this.$();
      for (var i in selector) {
        this['$' + i] = this.$(selector[i]);
      }
      // a single elements + extracting elements
    } else {
      this.$element = el = this.$(selector);
      this.$element.cache('module', this);
      this.extract(this.$element, this);
    }

    // merge the data with the data() from the $element
    var $data = this.$element.data();
    data = this.utils.extend($data || {}, data || {});
    this.set(data);

    return [el, data];
  }

  preInit(selector, data) {
    var $el = this.$element;
    let classname = (this.classname = this.utils.string.camel2dash(this.constructor.name));

    // remove the hidden attributes
    $el.find(true, '[hidden]').each(true, function ($child) {
      var $parent = $child.closest('[data-module]');

      if ($el.is($parent)) {
        $child.attr('hidden', '');
      }
    });

    // check for element ID
    var id = $el.attr('id') || this.id;
    this.id = id;
    $el.attr('id', id);

    // save the view to the node element
    var el = $el.get(0);
    if (el && !el.__view__) {
      el.__view__ = this;

      // Add Module classname as an html className
      classname = this.classname = this.utils.string.camel2dash(this.constructor.name);
      $el.addClass(classname);
      $el.attr('view', classname);
    }

    this.checkAndSetTargetBlankOnLink();
    this.$loader = this._loader();
  }

  isLoading(value, callback) {
    if (callback === 'loader') {
      callback = this.$loader || this.$body;
    }

    return super.isLoading(value, callback ? callback : this.$element);
  }

  extract($el, data) {
    data = data || {};

    $el = $el || this.$element;
    data.$self = $el;

    var root = $el.get(0);
    $el.find(true, '[element]').each(function (el) {
      // filter out the element that are contained in sub modules
      var parent = utils.dom.closest(el.parentNode, '[data-module]', root);
      if (parent && parent !== root) return;

      var id = '$' + el.getAttribute('element');
      data[id] = this.$(el);
      el.removeAttribute('element');
    });

    return data;
  }

  // Private -----------------------------------------------------------------
  _loader() {
    var el = this.$element.get(0);
    var view = el && el.__view__;
    if (view && view.$loader !== undefined) {
      return view.$loader;
    }

    var $loader = false;
    this.$element.parents('[view]').each(function (el) {
      var v = el.__view__;
      if (v && v.$loader) {
        $loader = v.$loader;
        return '__BREAK__';
      }
    });

    return $loader;
  }

  checkAndSetTargetBlankOnLink() {
    let $linkList = this.$('.journal--content.container a');
    for (const [key, node] of Object.entries($linkList)) {
      const isObj = typeof node === 'object';
      const isANode = isObj ? node?.nodeName?.toLowerCase() === 'a' : false;
      if (isANode) {
        const url = node.getAttribute('href');
        let isHttp = url.includes('http');
        if (isHttp) {
          const link = new URL(url);
          const isSameDomain = link.origin === window.origin;
          const target = node.getAttribute('target');
          if (!isSameDomain && !target) {
            let classList = node.getAttribute('class');
            classList = classList ? classList + ' exit' : 'exit';

            node.setAttribute('class', classList);
            node.setAttribute('target', '_blank');
          }
        }
      }
    }
  }

  // Events ------------------------------------------------------------------
  onStateChange(name, value, old) {
    if (this.$element) {
      var old = !utils.is(old) ? '' : old === true ? 'is-' + name : 'is-' + name + '-' + old;
      var value = !utils.is(value) ? '' : value === true ? 'is-' + name : 'is-' + name + '-' + value;
      this.$element.removeClass(old).addClass(value);
    }

    this.trigger('state-' + name + '-change', {
      value: value,
      old: old,
    });
  }

  onStatesChange(e) {}
}
